import {NgModule} from '@angular/core';
import {EntityDataService, EntityServices} from "@ngrx/data";
import {ProviderServiceRepository} from "./impl/service/ngrx/providerService.repository";
import {ProviderServiceDataService} from "./impl/service/ngrx/providerServiceData.service";
import {ProviderServiceOptionModule} from "./option/providerServiceOption.module";
@NgModule({
    providers: [],
    imports: [
        ProviderServiceOptionModule
    ]
})
export class ProviderServiceModule {

    constructor(entityDataService: EntityDataService,
                entityServices: EntityServices,
                repository: ProviderServiceRepository,
                dataService: ProviderServiceDataService,
    ) {

        entityDataService.registerServices({
            'ProviderService': dataService,
        });

        entityServices.registerEntityCollectionServices({
            'ProviderService': repository,
        });

        // errorMessages.set(PARTNER_SAVE_PERSON_ALREADY_PART_OF_THIS_TYPE, 'La personne sélectionnée est déjà %1');
    }
}
